export const DEAL_SECTION_KEYS = {
  GENERAL_INFORMATION: "general-information"

};

export const getTitleGroup = sectionKey => {
  switch (sectionKey) {
    case DEAL_SECTION_KEYS.GENERAL_INFORMATION:
      return ({
        title: "General Information",
        key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
        isTitleGroup: true
      });
  }
};

export const DATA_SOURCE_FACADE = Object.freeze({
  SERVICED: "serviced",
  PUBLIC: "public",
  SREO: "sreo",
});

export const DATA_SOURCES = Object.freeze({
  SERVICED: "DEAL_DATA_SOURCE_SERVICED",
  FREDDIE_MAC: "DEAL_DATA_SOURCE_FREDDIE_MAC",
  FANNIE_MAE: "DEAL_DATA_SOURCE_FANNIE_MAE",
  SREO: "DEAL_DATA_SOURCE_SREO",
  LOAN_DOCUMENTS: "DEAL_DATA_SOURCE_LOAN_DOCUMENTS",
});

export const DATA_SOURCE_FACADE_MAP = Object.freeze({
  [DATA_SOURCES.SERVICED]: DATA_SOURCE_FACADE.SERVICED,
  [DATA_SOURCES.FREDDIE_MAC]: DATA_SOURCE_FACADE.PUBLIC,
  [DATA_SOURCES.FANNIE_MAE]: DATA_SOURCE_FACADE.PUBLIC,
  [DATA_SOURCES.SREO]: DATA_SOURCE_FACADE.SREO,
});
